export function percHeight(size){
    return String(100*(size/(667*2)))+"%"
}

export function percWidth(size){
    return String(100*(size/(375*2)))+"%"
}